import { cx } from '@linaria/core';
import { wrapperCls, bulletCls } from './bullets.style.js';
import { jsx } from 'react/jsx-runtime';

function Bullets(props) {
  return /*#__PURE__*/jsx("div", {
    className: cx(wrapperCls, props.className),
    children: new Array(props.amount).fill(undefined).map((_, index) => /*#__PURE__*/jsx("div", {
      className: cx(bulletCls, index === props.current && "active")
    }, index))
  });
}

export { Bullets };
//# sourceMappingURL=bullets.js.map
